export class RegisterExternalBackground {
    get id() {
        return this.registerExternalBackgroundStateState.id;
    }
    get origin() {
        return this.registerExternalBackgroundStateState.origin;
    }
    get originName() {
        return this.registerExternalBackgroundStateState.originName;
    }
    get dateCreated() {
        return this.registerExternalBackgroundStateState.dateCreated;
    }
    get thirdId() {
        return this.registerExternalBackgroundStateState.thirdId;
    }
    get thirdName() {
        return this.registerExternalBackgroundStateState.thirdName;
    }
    get antecedentType() {
        return this.registerExternalBackgroundStateState.antecedentType;
    }
    get antecedentTypeName() {
        return this.registerExternalBackgroundStateState.antecedentTypeName;
    }
    get deadlineDate() {
        return this.registerExternalBackgroundStateState.deadlineDate;
    }
    get userId() {
        return this.registerExternalBackgroundStateState.userId;
    }
    set id(id) {
        this.registerExternalBackgroundStateState.id = id;
    }
    set origin(origin) {
        this.registerExternalBackgroundStateState.origin = origin;
    }
    set originName(originName) {
        this.registerExternalBackgroundStateState.originName = originName;
    }
    set dateCreated(dateCreated) {
        this.registerExternalBackgroundStateState.dateCreated = dateCreated;
    }
    set thirdId(thirdId) {
        this.registerExternalBackgroundStateState.thirdId = thirdId;
    }
    set thirdName(thirdName) {
        this.registerExternalBackgroundStateState.thirdName = thirdName;
    }
    set antecedentType(antecedentType) {
        this.registerExternalBackgroundStateState.antecedentType = antecedentType;
    }
    set antecedentTypeName(antecedentTypeName) {
        this.registerExternalBackgroundStateState.antecedentTypeName = antecedentTypeName;
    }
    set deadlineDate(deadlineDate) {
        this.registerExternalBackgroundStateState.deadlineDate = deadlineDate;
    }
    set userId(userId) {
        this.registerExternalBackgroundStateState.userId = userId;
    }
    constructor(registerExternalBackgroundStateState) {
        this.registerExternalBackgroundStateState = registerExternalBackgroundStateState;
    }
    getState() {
        return this.registerExternalBackgroundStateState;
    }
}
